import { createSelector } from '@reduxjs/toolkit'
import { Size } from '@spiaggeit/map-canvas'
import { MAP_CELL_SIZE } from '@/utils/constants'
import { licenseSlice } from '..'

export const mapSizeSelector = createSelector(
  [licenseSlice.selectors.license],
  (license): Size => {
    return {
      height: (license?.mapBgHeight ?? 0) * MAP_CELL_SIZE,
      width: (license?.mapBgWidth ?? 0) * MAP_CELL_SIZE,
    }
  }
)
